import { removeAttachmentFromHistoryEntry } from "../../api/historyService";

export const useRemoveAttachmentFromHistoryEntry = (successCallback) => {
    const removeAttachmentFromEntry = async (id, attachmentId) => {
        try {
            await removeAttachmentFromHistoryEntry(id, attachmentId);
            successCallback();
        } catch (error) {
            console.error("Failed to remove attachment from history entry:", error);
            throw error;
        }
    };

    return { removeAttachmentFromEntry };
};